const services = [
  {
    icon: 'ri-music-2-line',
    title: 'Music Production',
    description: 'Tailored music production built around each artist\'s individual vision, style, and goals. From the first idea to the final production, every project is shaped with a focus on quality, character, and a result that fits the artist as closely as possible.',
    tags: ['Production', 'Composition', 'Arrangement'],
  },
  {
    icon: 'ri-user-star-line',
    title: 'Artist Development',
    description: 'Creative and strategic development for artists, tracks, and release concepts. From shaping the musical direction to refining the overall presentation, with a strong focus on authenticity and long-term value.',
    tags: ['Creative Direction', 'Concept Development', 'Release Focus'],
  },
  {
    icon: 'ri-equalizer-line',
    title: 'Mixing & Mastering',
    description: 'Clean, powerful mixes and release-ready masters for both in-house productions and externally produced tracks. Each project is refined with attention to detail, strong translation, and the sonic impact required for streaming, club, and label release.',
    tags: ['Mixing', 'Mastering', 'Final Delivery'],
  },
  {
    icon: 'ri-disc-line',
    title: 'Label & Release Support',
    description: 'Practical release support based on long-standing experience with independent labels and artist projects. Includes release preparation, catalogue structuring, and strategic guidance around publishing and distribution workflows.',
    tags: ['Release Strategy', 'Label Support', 'Distribution Prep'],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="relative py-32 px-6 overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/904c39c7-cee9-42fd-88d5-af73a1c0520a_ChatGPT-Image-23.-Apr.-2026-22_18_50.png?v=9ad81c075d7a128fee62e23228c0d1c1"
          alt="Music studio atmosphere"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0d0d0d]/70" />
        {/* Top & bottom fade to black */}
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-white/30" />
          <span className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase">What We Offer</span>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <h2 className="text-white font-bold leading-tight" style={{fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em'}}>
            Full-Spectrum Music Services
          </h2>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed lg:text-right">
          From first demo to chart-topping release.<br />AceAge-Music provides everything an artist <br />needs to thrive in today&apos;s music industry.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/[0.08]">
          {services.map((service, i) => (
            <div
              key={i}
              className="bg-black/50 backdrop-blur-sm p-8 group hover:bg-black/75 border border-white/20 hover:border-white/35 transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-white/50 group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="text-white font-semibold text-lg mb-3">{service.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-6 group-hover:text-white/70 transition-colors duration-300">{service.description}</p>
              <div className="flex flex-wrap gap-2">
                {service.tags.map(tag => (
                  <span
                    key={tag}
                    className="text-xs text-white/30 border border-white/10 px-3 py-1 rounded-full group-hover:border-white/30 group-hover:text-white/60 transition-colors duration-300"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
